var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"highlight",rawName:"v-highlight"}]},[_c('pre',{staticClass:"language-javascript"},[_vm._v("  "),_c('code',[_vm._v("\n  "+_vm._s(_vm.script)+"\n  ")]),_vm._v("\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }